import React from 'react';
import ReactDOM from 'react-dom';
  
class SectionItems extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            items: props.items,
            RESTRICTION_NOTE: ''
        };
    }

    handleClickAddToCart = (id,unit,vendor_id,vendor_name,vendortype_id)=>{
        let cartCIRCLE = localStorage.getItem('cartCIRCLE');
        let circleID = localStorage.getItem('delCIRCLE2');
        if(cartCIRCLE === null || cartCIRCLE==='{}')
            localStorage.setItem('cartCIRCLE',circleID);

        let cartTotalCount = 0;
        let inCart = 'N';
        let addButton = 'Y';
        let cartCount = 0;

        var addToObject = function (obj, key, value, index) {
            // Create a temp object and index variable
            var temp = {};
            var i = 0;
        
            // Loop through the original object
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    // If the indexes match, add the new item
                    if (i === index && key && value) {
                        temp[key] = value;
                    }
                    // Add the current item in the loop to the temp obj
                    temp[prop] = obj[prop];
                    // Increase the count
                    i++;
                }
            }
        
            // If no index, add to the end
            if (!index && key && value) {
                temp[key] = value;
            }
            return temp;
        };
                
        let cart = localStorage.getItem('cartData');
        let cartVendorID = localStorage.getItem('cartVendorID');
        let cartVendorName = localStorage.getItem('cartVendorName');
        let cartVendorTypeID = localStorage.getItem('cartVendorTypeID');

        var that = this;
        if (cart === null) {
            var a = {[id+'~~**~~'+unit]: 1};            
            localStorage.setItem('cartData',JSON.stringify(a));
            localStorage.setItem('cartVendorID',vendor_id);
            localStorage.setItem('cartVendorName',vendor_name);
            localStorage.setItem('cartVendorTypeID',vendortype_id);

            let inCart = 'Y';
            let cartCount = 1;

            that.setState({ inCart:inCart, cartCount:cartCount});
            this.props.inCartCallBack();
        }
        else
        {
            let ALLOW_CART = 'Y';
            if(cartVendorID!=vendor_id)
            {
                let MSG = '';
                if(cartVendorTypeID!=vendortype_id)
                {
					if(cartVendorTypeID=='2')
						MSG = 'Items from '+ cartVendorName +' needs to be ordered independently. Please clear the cart if you wish to add items from '+vendor_name;
                    else if(vendortype_id=='2')
						MSG = 'Items from '+ vendor_name +' needs to be ordered independently. Please clear the cart if you wish to add items from '+vendor_name;

                    ALLOW_CART = 'N';
                }
                else
                {
                    if(cartVendorTypeID=='2' && vendortype_id=='2')
                    {
						MSG = 'Items from '+ vendor_name +' needs to be ordered independently. Please clear the cart if you wish to add items from '+vendor_name;
                        ALLOW_CART = 'N';
                    }
                }

                if(ALLOW_CART=='N')
                {
                    that.setState({RESTRICTION_NOTE:MSG});
                    $('#ModalCartItemRestriction_'+id).modal('show');
                }
            }

            if(ALLOW_CART=='Y')
            {
                var cartData = JSON.parse(cart);
                Object.keys(cartData).forEach(function(key) {
                    let cart_id = key.split('~~**~~');
                    if(cart_id[0]==id)
                        cartTotalCount += cartData[key];
        
                    if(cart_id[0]==id && unit==cart_id[1])
                        delete cartData[key];
                });
                cartTotalCount += 1;

                cartData = addToObject(cartData, [id+'~~**~~'+unit], 1);
                localStorage.setItem('cartData', JSON.stringify(cartData));

                let inCart = 'Y';
                let cartCount = 1;
                that.setState({ inCart:inCart, cartCount:cartTotalCount});
                this.props.inCartCallBack();
            }
        }    
    }

    handleClickIncreement = (id,unit,cartCount,itemqty_cart)=>{
        let cartTotalCount = 0;
        if(itemqty_cart!==0 && cartCount<itemqty_cart)
        {
            cartCount = cartCount + 1;

            let cart = localStorage.getItem('cartData');
            var that = this;
            var cartData = JSON.parse(cart);
            Object.keys(cartData).forEach(function(key) {
                let cart_id = key.split('~~**~~');
                if(cart_id[0]==id)
                    cartTotalCount += cartData[key];

                if(cart_id[0]==id && unit==cart_id[1])
                    cartData[key] = cartCount;
            });
            cartTotalCount += 1;

            localStorage.setItem('cartData', JSON.stringify(cartData));

            let inCart = 'Y';
            cartCount = cartCount;
            that.setState({ inCart:inCart, cartCount:cartTotalCount});
            this.props.inCartCallBack();
        }
        else
            $('#ModalCartItemLimit_'+id).modal('show');
    }

    handleClickDecreement = (id,unit,cartCount)=>{
        
        cartCount = (cartCount!=0)?cartCount - 1:0;
        let cart = localStorage.getItem('cartData');
        var that = this;
        var cartData = JSON.parse(cart);
        Object.keys(cartData).forEach(function(key) {
            let cart_id = key.split('~~**~~');
            if(cart_id[0]==id && unit==cart_id[1])
            {
                if(cartCount==0)
                    delete cartData[key];
                else
                    cartData[key] = cartCount;
            }
        });

        localStorage.setItem('cartData', JSON.stringify(cartData));
        cart = localStorage.getItem('cartData');
        if(cart === null || cart ==='{}')
        {
            localStorage.removeItem('cartCIRCLE');
            localStorage.removeItem('cartInstructions');
            localStorage.removeItem("cartData");
            localStorage.removeItem('cartVendorID');
            localStorage.removeItem('cartVendorName');
            localStorage.removeItem('cartVendorTypeID');
        }

        let inCart = (cartCount==0)?'N':'Y';
        cartCount = cartCount;
        that.setState({ inCart:inCart, cartCount:cartCount});
        this.props.inCartCallBack();
    }

    render() { 
        return(
            this.state.items.map(item=>{
                
                let inCart = 'N'; //this.state.inCart;
                let added = ''; //this.state.addButton;
                let cartCount = 0; //this.state.cartCount;
        
                let currentITEM = item.ID;
                let cart = localStorage.getItem('cartData');
                if (cart !== null) {
                    let cartData = JSON.parse(cart);
                    Object.keys(cartData).forEach(function(key) {
                        let id = key.split('~~**~~');
                        if(id[0]==currentITEM)
                        {
                            inCart = 'Y';
                            added = 'add-btn-inc';
                            cartCount += cartData[key];
                        }
                    });
                }

                let OfferType = '';
                let OfferType2 = '';
                if(item.OFFER_TYPE!=='')
                {
                    if(item.OFFER_TYPE=='PER') OfferType = '%';
                    if(item.OFFER_TYPE=='DIS') OfferType = '&#8377;';
                }
                        
                return (
                    <div className="col-6" key={item.ID}>
                        <div className="card  mb-2">
                            {item.OFFER!='' && <div className="chip off-tags chip-warning"><span className="chip-label">{OfferType2}{item.OFFER}{OfferType} Off</span></div>}
                            <img src={item.PIC} className="card-img-top imaged w-100" alt="image" />
                            <div className="card-body pt-07 pb-07 pr-06 pl-06">
                                <p className="card-text text-dgrey font-size-14 font-weg-400 mb-0">{item.NAME}</p>
                                <p className="mb-0 text-slgrey">
                                    <small>Per {item.UNIT}</small>
                                </p>
                                <p className="mb-0 font-weg-600">
                                    {item.MRP!=='0.00' && item.MRP!==item.RATE && <span className="del-price text-slgrey"><del>&#8377;{item.MRP}</del></span>}
                                    <span className="final-price text-danger font-size-14">&#8377; {item.RATE}</span>
                                </p>
                                {item.AVAILABLE_QTY>0 &&
                                    <div>
                                        <div className={`add-btn ${added} mt-2`}>
                                            <input type="button" onClick={()=>{this.handleClickDecreement(item.ID,item.UNIT,cartCount)}} value="-" className="qtyminus" />
                                            <input type="text" value={cartCount} readOnly className="qty" />
                                            {inCart=='Y' && <input type="button" onClick={()=>{this.handleClickIncreement(item.ID,item.UNIT,cartCount,item.QTY_PER_CART)}}  value="+" className="qtyplus"/>}
                                            {inCart=='N' && <input type="button" onClick={()=>{this.handleClickAddToCart(item.ID,item.UNIT,item.VENDOR_ID,item.VENDOR_NAME,item.VENDORTYPE_ID)}}  value="+" className="qtyplus"/>}
                                        </div>
                                        <div className="modal fade dialogbox" id={`ModalCartItemLimit_${item.ID}`} data-backdrop="static" tabIndex="-1" role="dialog">
                                            <div className="modal-dialog" role="document">
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title">&nbsp;</h5>
                                                    </div>
                                                    <div className="modal-body"> 
                                                        You have reached the limit for this item
                                                    </div>
                                                    <div className="modal-footer">
                                                        <div className="btn-inline"> 
                                                            <button type="button" className="btn" data-dismiss="modal">Ok</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal fade dialogbox" id={`ModalCartItemRestriction_${item.ID}`} data-backdrop="static" tabIndex="-1" role="dialog">
                                            <div className="modal-dialog" role="document">
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title">&nbsp;</h5>
                                                    </div>
                                                    <div className="modal-body"> 
                                                        {this.state.RESTRICTION_NOTE}
                                                    </div>
                                                    <div className="modal-footer">
                                                        <div className="btn-inline"> 
                                                            <button type="button" className="btn" data-dismiss="modal">Ok</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {item.AVAILABLE_QTY==0 &&
                                    <div className="add-btn add-btn-incr mt-2 font-size-12">
                                        Out Of Stock
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                );
            })
        );
    }
}
      
export default SectionItems;


// WEBPACK FOOTER //
// ./src/components/SectionItems.js